import React from 'react'

const IconWrong= ({fillColor,style}) => {
  return (
    
   <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M346.92-160 160-346.92v-266.16L346.92-800h266.16L800-613.08v266.16L613.08-160H346.92ZM366-337.69l114-114 114 114L622.31-366l-114-114 114-114L594-622.31l-114 114-114-114L337.69-594l114 114-114 114L366-337.69ZM364-200h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/>
   </svg>
  )
}
export default IconWrong 